<template>
    <div>
        <h4 class="fw-b mb-24">{{ $t('pages.profile.personal_settings')}}</h4>
        <h6 class="fw-b mb-24">{{ $t('pages.profile.basic_settings') }}</h6>

        <el-form v-if="personal_info" @submit="submit">

            <template slot="default">

                <el-error class="mb-16" :error="server_error"></el-error>

                <div class="form-content">
                    <div class="row mb-32">
                        <div class="col-12 col-lg-6">
                            <div class="form-row">
                                <el-input class="col-6" v-model="currentUser.first_name" name="first_name" :label="$t('form-elements.first_name')" :placeholder="$t('form-elements.first_name_placeholder')"></el-input>
                                <el-input class="col-6" v-model="currentUser.last_name" name="last_name" :label="$t('form-elements.last_name')" :placeholder="$t('form-elements.last_name_placeholder')"></el-input>
                                <el-input class="col-12" v-model="currentUser.email" :disabled="true" name="email" type="email" :label="$t('form-elements.email')" :placeholder="$t('form-elements.email_placeholder')"></el-input>
                                <div class="col-12"><label class="text-primary-dark small" :for="$t('form-elements.street_placeholder')">{{$t('form-elements.street')}}</label></div>
                                <el-input class="col-12 col-lg-8" :rule="addressRequired() ? 'required' : null" v-model="personal_info.street" :name="$t('form-elements.street_placeholder')" :hasLabel="false" :placeholder="$t('form-elements.street_placeholder')"></el-input>
                                <el-input class="col-6 col-lg-2" :rule="addressRequired() ? 'required' : null" v-model="personal_info.number" :name="$t('form-elements.number_placeholder')" :hasLabel="false" :placeholder="$t('form-elements.number_placeholder')"></el-input>
                                <el-input class="col-6 col-lg-2" v-model="personal_info.bus" :name="$t('form-elements.bus_placeholder')" :hasLabel="false" :placeholder="$t('form-elements.bus_placeholder')"></el-input>
                                <el-input class="col-4" :rule="addressRequired() ? 'required' : null" v-model="personal_info.zip" :name="$t('form-elements.postal_placeholder')" :hasLabel="false" :placeholder="$t('form-elements.postal_placeholder')"></el-input>
                                <el-input class="col-8" :rule="addressRequired() ? 'required' : null" v-model="personal_info.city" :name="$t('form-elements.city_placeholder')" :hasLabel="false" :placeholder="$t('form-elements.city_placeholder')"></el-input>
                                <el-select class="col-12" :rule="addressRequired() ? 'required' : null" v-model="country" @input="personal_info.country = country.value" name="country" :options="[{ value: 'be', label: $t(`countries.be`) }, { value: 'nl', label: $t(`countries.nl`) }, { value: 'fr', label: $t(`countries.fr`) },{ value: 'de', label: $t(`countries.de`) }]" :hasLabel="false" :label="$t('form-elements.country')" :placeholder="$t('form-elements.country_placeholder')"></el-select>
                                <el-select class="col-12" v-model="lang" @input="currentUser.locale = lang.value" name="language" :options="languages" :label="$t('form-elements.language')" :placeholder="$t('form-elements.language_placeholder')"></el-select>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6">
                            <div class="form-row">
                                <el-select class="col-12" v-model="gender" @input="personal_info.gender = gender.value" name="gender" :options="[{ value: 'm', label: $t(`genders.m`) }, { value: 'v', label: $t(`genders.v`) }]" :label="$t('form-elements.gender')" :placeholder="$t('form-elements.gender_placeholder')"></el-select>
                                <el-input class="col-12" v-model="currentUser.phone" name="phone" :label="$t('form-elements.phone')" :placeholder="$t('form-elements.phone_placeholder')">
                                    <template slot="input-cta">{{ $t('general.optional') }}</template>
                                </el-input>
                                <datepicker class="col-12 mb-16" initial-view="year" v-model="personal_info.birth_date" :bootstrap-styling="true" name="birthdate" :label="$t('form-elements.birthdate')" :placeholder="$t('form-elements.birthdate_placeholder')"></datepicker>
                                <el-select v-model="know_us_source" @input="profession.know_us_source_id = know_us_source.id" rule="" :translate="true" direction="top" class="col-12" labelKey="name" valueKey="id" :options="knowUsSources" :name="$t('form-elements.how_do_you_know_us')" :label="$t('form-elements.how_do_you_know_us')" :placeholder="$t('form-elements.how_do_you_know_us_placeholder')"></el-select>
                            </div>
                        </div>
                    </div>

                    <div class="form-row">

                        <div class="col-12">
                            <h6 class="fw-b mb-24">{{ $t('pages.onboarding-personal.global_medical_info') }}</h6>
                        </div>

                        <div class="col-12 col-lg-3 d-flex">
                            <p class="my-auto small">{{ $t('form-elements.doctor') }}</p>
                        </div>
                        <div class="col-12 col-lg-9">
                            <el-input v-model="personal_info.physician" type="text" rule="required" :name="$t('form-elements.doctor')" :hasLabel="false" :placeholder="$t('form-elements.doctor_placeholder')" />
                        </div>
                    </div>

                    <div class="form-row mb-32">
                        <div class="col-12 col-lg-3 d-flex">
                            <p class="my-auto small">{{ $t('form-elements.insurance') }}</p>
                        </div>
                        <div class="col-12 col-lg-9">
                            <el-input v-model="personal_info.health_insurance" type="text" rule="required" :name="$t('form-elements.insurance')" :hasLabel="false" :placeholder="$t('form-elements.insurance_placeholder')" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <h6 class="fw-b mb-24">{{ $t('pages.onboarding-personal.psychological_complaints') }}</h6>
                        </div>
                        <div class="col-12 col-lg-3 d-flex mb-16">
                            <p class="my-auto small">{{ $t('form-elements.psychologist') }}</p>
                        </div>
                        <div class="col-12 col-lg-9 mb-32">
                            <p-input type="radio" name="checkbox" class="p-default p-round p-smooth text-wrap mr-16" color="success-o" :checked="has_psychologist" :value="has_psychologist" @change="() => { has_psychologist = true }">{{ $t('general.yes') }}</p-input>
                            <p-input type="radio" name="checkbox" class="p-default p-round p-smooth text-wrap" color="success-o" :checked="!has_psychologist" :value="!has_psychologist" @change="() => { has_psychologist = false; personal_info.psychologist = null }">{{ $t('general.no') }}</p-input>
                        </div>
                        <div v-if="has_psychologist" class="col-12 col-lg-9 offset-lg-3 mb-16">
                            <el-input v-model="personal_info.psychologist" type="text" rule="required" :name="$t('form-elements.name_psychologist')" :label="$t('form-elements.name_psychologist')" :placeholder="$t('form-elements.name_psychologist_placeholder')" />
                        </div>

                        <div class="col-12 col-lg-3 d-flex mb-32">
                            <p class="my-auto small pr-lg-16">{{ $t('form-elements.psychological_complaints') }}</p>
                        </div>
                        <el-psychological-compaints class="col-12 col-lg-9 mb-32" v-model="personal_info.psychological_complaint_ids" :user_id="currentUser.user.id"></el-psychological-compaints>

                        <div class="col-12 col-lg-9 offset-lg-3">
                            <el-input v-model="personal_info.psychological_complaint_reason" type="text" rule="max:100" :name="$t('form-elements.specify')" :label="$t('form-elements.specify')" :placeholder="$t('form-elements.specify_placeholder')">
                                <template v-if="personal_info.psychological_complaint_reason" slot="label-cta">
                                    <span class="ml-auto"> {{ personal_info.psychological_complaint_reason.length }} / 100</span>
                                </template>
                            </el-input>
                        </div>

                        <div class="col-12 col-lg-6 mt-32 d-none">
                            <p class="mb-4 fw-b">{{ $t('pages.profile.reset_account_title') }}</p>
                            <p class="mb-16 small">{{ $t('pages.profile.reset_account_desc') }}</p>
                            <a href="#" class="btn btn-outline-gold">{{ $t('pages.profile.reset_account') }}</a>
                        </div>
                    </div>
                </div>
            </template>

            <template slot="footer">
                <div class="form-footer position-fixed px-lg-60">
                    <button class="btn btn-primary btn-block btn-lg-inline d-block d-lg-flex" v-bind:class="{ disabled : loading }">
                        {{ $t('general.save') }}
                        <template v-if="loading">
                            <i-loader class="ml-2 i-20 my-auto"></i-loader>
                        </template>
                        <template v-if="success">
                            <i-check class="ml-2 i-20 my-auto"></i-check>
                        </template>
                    </button>
                </div>
            </template>

        </el-form>
    </div>
</template>

<script>
import { ElInput, ElSelect, ElForm, ElError, PInput, ElPsychologicalCompaints } from '@/components/forms'
import Datepicker from 'vuejs-datepicker';

// Extends
import { loadLanguageAsync } from '@/i18n'
import hasLanguages from '@/components/forms/has-languages';
import hasForm from '@/components/forms/has-form';

export default {
    name: 'page-profile-settings',

    mixins: [hasForm, hasLanguages],

    components: { ElInput, ElSelect, ElForm, ElError, PInput, Datepicker, ElPsychologicalCompaints },

    data: () => ({
        update: null,

        country: { label: '', value: '' },
        gender: { label: '', value: '' },
        has_psychologist: false,
        know_us_source: '',

        personal_info: {
            street: null,
            number: null,
            bus: null,
            zip: null,
            city: null,
            country: null,
            psychologist: null,
            gender: null,
            birth_date: null,
            physician: null,
            health_insurance: null,
            psychological_complaint_ids: [],
            psychological_complaint_reason: null,
        },
        profession: {
            know_us_source_id: null,
        }
    }),
    mounted() {
        this.$store.dispatch('general/professionTypes')
        this.$store.dispatch('general/knowUsSources')
        this.setLanguage(this.currentUser.locale)

        if (this.currentUser.user && this.currentUser.user.personal_info_id)
            this.$store.dispatch('user/readPersonalInfo', { user_id: this.currentUser.user.id, id: this.currentUser.user.personal_info_id }).then((personal_info) => {
                this.personal_info = Object.assign({}, personal_info)

                this.country = personal_info.country ? { label: this.$t(`countries.${personal_info.country}`), value: personal_info.country } : { label: '', value: '' }
                this.gender = personal_info.gender ? { label: this.$t(`genders.${personal_info.gender}`), value: personal_info.gender } : { label: '', value: '' }

                if (this.personal_info.psychologist !== null) this.has_psychologist = true
                this.update = true
            })

        if (this.currentUser.user && this.currentUser.user.profession_id)
            this.$store.dispatch('user/readProfession', { user_id: this.currentUser.user.id, id: this.currentUser.user.profession_id }).then((profession) => {
                this.know_us_source = this.knowUsSources.find((ku) => ku.id === profession.know_us_source_id)
                this.profession.know_us_source_id = profession.know_us_source_id
                this.profession.id = profession.id
                this.profession.profession_type_id = profession.profession_type_id
                this.profession.reason = profession.reason
                this.profession.profession = profession.profession
            })
    },
    methods: {
        submit() {
            this.$validator.validateAll().then(res => {
                if (res) {
                    this.loading = true
                    let promises = []
                    let user_id = this.currentUser.user.id
                    if (this.personal_info.birth_date)
                        this.personal_info.birth_date = this.$moment(this.personal_info.birth_date).format('YYYY-MM-DD')
                    promises.push(this.$store.dispatch(`user/${!this.update ? 'createPersonalInfo' : 'updatePersonalInfo'}`, { user_id, data: this.personal_info }))
                    promises.push(this.$store.dispatch(`user/updateProfession`, { user_id, data: this.profession }))
                    promises.push(this.$store.dispatch(`user/update`, { user_id, data: { first_name: this.currentUser.first_name, last_name: this.currentUser.last_name, newsletter: this.currentUser.user.newsletter, locale: this.currentUser.locale, phone: this.currentUser.phone } }))

                    Promise.all(promises).then(
                        () => {
                            this.loading = false
                            this.success = true
                            this.update = true

                            loadLanguageAsync(this.currentUser.locale).then(() => {
                                this.setLanguage(this.currentUser.locale)
                                this.$nextTick(() => {
                                    this.$toasted.global.info({
                                        title: this.$t('toasts.success_update_profile'),
                                        description: this.$t('toasts.success_update_profile_desc'),
                                    });
                                })
                            })

                        },
                        error => {
                            this.loading = false
                            this.success = false
                            this.server_error = error
                        },
                    );
                }
            })
        },
        addressRequired() {
            return this.personal_info.street || this.personal_info.number || this.personal_info.zip || this.personal_info.city || this.personal_info.country || this.personal_info.bus
        }
    },
    computed: {
        currentUser() {
            return this.$store.getters['user/currentUser']
        },
        professionTypes() {
            return this.$store.getters['general/professionTypes']
        },
        knowUsSources() {
            return this.$store.getters['general/knowUsSources']
        }
    }
}
</script>
